// =============================================================================
//  Copyright : 2025 semantics GmbH
//  Date      : $Date: 2025-11-27 00:02:26 +0100 (Thu, 27 Nov 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 158680 $
//  Purpose   : glossary support
// =============================================================================
export const parts = true;
export const nodemenu = true;
import * as views from './views';
export { views };
